import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DocumentCategoryDocumentTypeMatrix } from './documentCategoryDocumentTypeMatrix';

export const checkDocCategoryAndDocTypeAllowedRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const documentCategory = control.get('documentCategory')!.value;
	const documentType = control.get('documentType')!.value;
	return !!documentCategory && !!documentType
	  && !DocumentCategoryDocumentTypeMatrix.getDocumentTypePossibilities(documentCategory).includes(documentType)  ? { checkDocCategoryAndDocTypeAllowedFlagr: true } : null;
};
